






import { defineComponent, ref } from '@vue/composition-api';
import { useActions } from 'vuex-composition-helpers';

export default defineComponent({
  setup(props, { emit }) {
    const { deleteBankMandate } = useActions(['deleteBankMandate']);
    const deleting = ref<boolean>(false);

    return {
      deleting,
      deleteBankMandate: async (bankMandateId: string) => {
        deleting.value = true;
        await deleteBankMandate(bankMandateId);
        deleting.value = false;

        emit('deleted');
      },
    };
  },
});
